import restClient from "../restClient";

export const getUsers = async (page, pageSize) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`tenant-users?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};



export const searchTenantUsers = async (searchStr = '') => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // Adjust URL as needed if the search parameter works differently for tenant-users
    // Example: `tenant-users?filters[$or][0][user_detail][full_name][$contains]=${searchStr}&filters[$or][1][email][$contains]=${searchStr}&populate=*`
    // Or if the backend simply takes a top-level `search` param:
    let url = `tenant-users?pagination[page]=1&pagination[pageSize]=20&populate=*`;
    if (searchStr) {
      // Assuming a generic search parameter based on Customer pattern
      url += `&search=${encodeURIComponent(searchStr)}`;
    }
    const response = await restClient.get(url, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUserPermissions = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`user-role-permissions?filters[main_status][$eq]=1&populate=*`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getUserDetail = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`tenant-user/${userId}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getSAUserDetail = async (userId, tenantId = null) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `sa/user-detail/${userId}`;
    if (tenantId) {
      url += `?tenantId=${tenantId}`;
    }
    const response = await restClient.get(url, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const createTenantUser = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`tenant-user`, { data: data }, config);
    return response.data;
  } catch (err) {
    throw err; // Throw the error instead of returning it
  }
};


export const updateTenantUser = async (userId, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`tenant-user/${userId}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err; // Throw the error instead of returning null
  }
};

export const updateSAUser = async (userId, tenantId, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`sa/user/${userId}?tenantId=${tenantId}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteTenantUser = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`tenant-user/${userId}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err; // Throw the error instead of returning null
  }
};

export const deleteSAUser = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`sa/user/${userId}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};